export default __webpack_public_path__ + "static/Brandon-Regular-400-3d365cb839289a196be8c195e26d8ed1.woff2";